import { useTranslation } from "react-i18next";

import { InputNumber } from "#components/atoms/InputNumber/InputNumber";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useUpdateQuoteRequestLineQuantity } from "#modules/quoteRequestLines/view/useUpdateQuoteRequestLineQuantity";

type Props = {
  line: QuoteRequestLineDto;
};

const QuantityCell = ({ line }: Props) => {
  const { updateQuoteRequestLineQuantity } = useUpdateQuoteRequestLineQuantity();
  const { t } = useTranslation();

  return (
    <InputNumber
      placeholder={t("quoteRequestV2.column.quantityPlaceholder")}
      value={line.quantity}
      onChange={(quantity) =>
        updateQuoteRequestLineQuantity({ id: line.id, payload: { quantity } })
      }
      size="sm"
    />
  );
};

export { QuantityCell };
